(function () {
  'use strict';
  angular.module('vcdms.vcpdfprinter')
    .component('pdfprinternew', {
      restrict: 'E',
      bindings: {
      },
      template: `
      <div class="pdfprinternew-component" data-hook="pdfprinternew-component">
        <h3>Neue/s pdfprinter anlegen</h3>
        <div class="btn btn-success" ng-click="vm.addPdfprinter()" ng-hide="vm.newpdfprinter">Neue/s pdfprinter anlegen</div>
        <div ng-show="vm.newpdfprinter">
          <pdfprinterform pdfprinter="vm.newpdfprinter" parentsave="vm.saveNewPdfprinter(pdfprinter)" oncancel="vm.cancel()"></pdfprinterform>
        </div>
        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> pdfprinter erfolgreich angelegt!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen eines/r neuen pdfprinter wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> pdfprinter konnte nicht angelegt werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Pdfprinter', 'Rlog',
        function ($log, Pdfprinter, Rlog) {
          let vm = this;
          vm.addPdfprinter = addPdfprinter;
          vm.saveNewPdfprinter = saveNewPdfprinter;
          vm.cancel = cancel;
          
          function addPdfprinter() {
            vm.newpdfprinter = {};
            delete vm.created;
            delete vm.canceled;
          }
          
          function saveNewPdfprinter(pdfprinter) {
            $log.debug('debug: create new pdfprinter: ', pdfprinter);
            delete vm.newpdfprinter;
            Pdfprinter.$create(pdfprinter).$then(function () {
              vm.created = true;
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new pdfprinter failed: ', err);
              Rlog.error('vcutils.pdfprinter', 'pdfprinternew', 'Creation of new pdfprinter failed: ', {pdfprinter: vm.newpdfprinter});
            });
          }
          
          function cancel() {
            delete vm.newpdfprinter;
            vm.canceled = true;
          }
        }] // controller
    }); // component

// klammerfriedhof
}());
